/* Matraws mega-nav — interaktioner.
   Åbner på hover (med intent-delay) og klik; lukker på Esc, klik udenfor,
   scroll og mouseleave. Panelet positioneres fixed under headeren. */
(function () {
  if (window.__mtwMegaNav) return;
  window.__mtwMegaNav = 1;

  var OPEN_DELAY = 60, CLOSE_DELAY = 170;

  function init() {
    var nav = document.querySelector('[data-mtw-mn]');
    if (!nav) return;

    var items = [];
    var current = null;
    var timer = null;

    // Glidende gul markør bag topbar-punkterne
    nav.classList.add('mtw-mn--js');
    var slider = document.createElement('span');
    slider.className = 'mtw-mn-slider';
    slider.setAttribute('aria-hidden', 'true');
    nav.insertBefore(slider, nav.firstChild);

    function moveSlider(el) {
      var fresh = !slider.classList.contains('is-on');
      if (fresh) slider.style.transition = 'none';
      slider.style.left = el.offsetLeft + 'px';
      slider.style.top = el.offsetTop + 'px';
      slider.style.width = el.offsetWidth + 'px';
      slider.style.height = el.offsetHeight + 'px';
      if (fresh) {
        void slider.offsetWidth;   // reflow, så første placering ikke animerer
        slider.style.transition = '';
      }
      slider.classList.add('is-on');
    }
    function hideSlider() { slider.classList.remove('is-on'); }

    nav.querySelectorAll('.mtw-mn-plain:not(.mtw-mn-cta):not(.mtw-mn-noslide)').forEach(function (a) {
      a.addEventListener('mouseenter', function () { if (!current) moveSlider(a); });
    });
    nav.addEventListener('mouseleave', hideSlider);

    function headerBottom() {
      var h = document.querySelector('.main-header') || nav.closest('header') || nav;
      var r = h.getBoundingClientRect();
      return Math.max(0, Math.round(r.bottom));
    }

    var GAP = 0;   // flush — panelet forbindes sømløst under baren (blød skygge i CSS)

    function open(item) {
      if (current === item) return;
      if (current) closeNow(current);
      hideSlider();   // det åbne punkt har sin egen gule knap-stil
      var top = headerBottom() + GAP;
      item.panel.style.top = top + 'px';
      item.panel.style.setProperty('--mtwTop', top + 'px');
      item.panel.hidden = false;
      item.btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mtw-mn-open');
      current = item;
      scrollAtOpen = window.scrollY;
    }

    function closeNow(item) {
      item.panel.hidden = true;
      item.btn.setAttribute('aria-expanded', 'false');
      if (current === item) {
        current = null;
        document.body.classList.remove('mtw-mn-open');
      }
    }

    function closeAll() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (current) closeNow(current);
    }

    function schedule(fn, ms) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(fn, ms);
    }

    nav.querySelectorAll('.mtw-mn-item').forEach(function (li) {
      var btn = li.querySelector('[data-mtw-mn-btn]');
      var panel = li.querySelector('[data-mtw-mn-panel]');
      if (!btn || !panel) return;
      var item = { li: li, btn: btn, panel: panel };
      items.push(item);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (current === item) closeAll();
        else { if (timer) clearTimeout(timer); open(item); }
      });

      btn.addEventListener('mouseenter', function () { if (!current) moveSlider(btn); });

      li.addEventListener('mouseenter', function () {
        schedule(function () { open(item); }, OPEN_DELAY);
      });
      li.addEventListener('mouseleave', function () {
        schedule(function () { if (current === item) closeNow(item); }, CLOSE_DELAY);
      });

      // Stagger-indeks til entrance-koreografien (CSS animation-delay)
      panel.querySelectorAll('[data-mtw-mn-pane]').forEach(function (p) {
        var els = p.querySelectorAll('.mtw-mn-chip, .mtw-mn-link');
        for (var i = 0; i < els.length; i++) els[i].style.setProperty('--i', Math.min(i, 18));
      });
      var bodyEls = panel.querySelectorAll('.mtw-mn-body--wall .mtw-mn-tile, .mtw-mn-body--mix .mtw-mn-tile, .mtw-mn-body--mix .mtw-mn-mcol h4, .mtw-mn-body--mix .mtw-mn-link');
      for (var bi = 0; bi < bodyEls.length; bi++) bodyEls[bi].style.setProperty('--i', Math.min(bi, 20));
      var rows = panel.querySelectorAll('.mtw-mn-row');
      for (var ri = 0; ri < rows.length; ri++) rows[ri].style.setProperty('--i', Math.min(ri, 14));

      // Faner i panelet
      var tabs = panel.querySelectorAll('[data-mtw-mn-tab]');
      var panes = panel.querySelectorAll('[data-mtw-mn-pane]');
      function activate(idx) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-mtw-mn-tab') === String(idx);
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          var on = p.getAttribute('data-mtw-mn-pane') === String(idx);
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
      }
      tabs.forEach(function (t) {
        var idx = t.getAttribute('data-mtw-mn-tab');
        t.addEventListener('mouseenter', function () { activate(idx); });
        t.addEventListener('click', function () { activate(idx); });
        t.addEventListener('keydown', function (e) {
          var n = parseInt(idx, 10);
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            var next = e.key === 'ArrowDown' ? n + 1 : n - 1;
            var target = panel.querySelector('[data-mtw-mn-tab="' + next + '"]');
            if (target) { target.focus(); activate(next); }
          }
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) {
        var btn = current.btn;
        closeAll();
        btn.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (current && !current.li.contains(e.target)) closeAll();
    });
    var scrollAtOpen = 0;
    window.addEventListener('scroll', function () {
      if (current && Math.abs(window.scrollY - scrollAtOpen) > 40) closeAll();
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (current) {
        var top = headerBottom() + GAP;
        current.panel.style.top = top + 'px';
        current.panel.style.setProperty('--mtwTop', top + 'px');
      }
    });

    // Luk når fokus forlader menuen (tab-navigation)
    nav.addEventListener('focusout', function () {
      requestAnimationFrame(function () {
        if (current && !current.li.contains(document.activeElement)) closeAll();
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
